module.exports = __webpack_public_path__ + "img/病人头像@3x.5e1953b2.png";